export default "__VITE_PUBLIC_ASSET__027ab42b__"